import React from "react";
import "./Feeds.css";
import ProfilePic from "components/General/ProfilePic";
import * as CONSTANT from "constants/text";
import { Fragment } from "react";
import { FaAngleDoubleRight } from "react-icons/fa";
import { Player } from "video-react";

export default function CustomUserPost(props) {
  /*Copied from UserStartedProject*/
  let event = new Date(props.time);
  const formattedDate = Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(event);
  const time = event.toLocaleTimeString("en-US");
  
  return (
    <Fragment>
      <div className="post_title_container">
        <div className="mobile-profile-pic">
          <ProfilePic
            className="profile-pic"
            alt={props.userName + "'s profile pic"}
            profilePic={props.userPhoto}
          />
        </div>
        <div className="name_date_text_stack">
          {props.isGroup ? (
            <label style={{ fontWeight: "bold" }} className="group-post-label">
              <span>{props.userName}</span>{" "}
              <span>
                <FaAngleDoubleRight size={18} style={{ fill: "#1a3867" }} />
              </span>{" "}
              <a href={"/groups/view/"+props.groupID+"/"+props.groupName}>{props.groupName}</a>
            </label>
          ) : (
            <label style={{ fontWeight: "bold" }}>{props.userName}</label>
          )}

          <label>{`${CONSTANT.POSTED_ON} ${formattedDate} ${time}`}</label>
        </div>
      </div>

      {props.postPhoto ? (
        <img
          className="post_photo"
          src={props.postPhoto}
          alt={props.postPhoto}
        />
      ) : null}
      {
        props.postVideo?(
          <div className="add_post_image" style={{ marginBottom: '12px' }}>
            <Player
              className="video-upload-preview"
              fluid={false}
              playsInline
              src={props.postVideo}
            />
          </div>
        ):null
      }
      {props.youtubeID ? (
        <div className="uploaded_photo" style={{ marginBottom: "25px" }}>
          <iframe
            width="100%"
            height="320px"
            src={"https://www.youtube.com/embed/" + props.youtubeID + "?rel=0"}
            frameborder="0"
            title="youtube player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      ) : null}

      <div className="post_body">
        <label>{props.postBody}</label>
      </div>
    </Fragment>
  );
}
